import './404'
import './article-image'
import './article-paragraph'
import './article-testimonial'
import './article-title'
import './business-pillars'
import './card-image'
import './careers'
import './cases'
import './clients'
import './contact-form'
import './cookies'
import './cta'
import './dropdown-interactive-text'
import './full-width-image'
import './hero'
import './hero-home'
import './industries'
import './intro'
import './news'
import './newsletter'
import './numbers'
import './office-locator'
import './pillars'
import './project-leader'
import './service-providers'
import './single-category-news'
import './value-proposition'
import './we-count-on'
import './who-we-are'
import './case-presentation'
import './video'
import './pillars-incase'
import './cases-filter'
import './image-slider'
import './big-image-slider'
import './cases-slider'
